import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { AuthCard } from '../components/AuthCard';
import { Field } from '../components/Field';
import { Alert } from '../components/Alert';
import { api } from '../lib/api';

export function ForgotPasswordPage() {
  const [sent, setSent] = useState(false);
  const [pending, setPending] = useState(false);

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setPending(true);
    const form = new FormData(event.currentTarget);
    // Réponse identique que le compte existe ou non : pas d'énumération d'e-mails.
    await api.post('/auth/forgot-password', { email: form.get('email') }).catch(() => undefined);
    setSent(true);
    setPending(false);
  }

  return (
    <AuthCard title="Mot de passe oublié" subtitle="Nous vous enverrons un lien de réinitialisation.">
      {sent ? (
        <Alert
          message="Si un compte existe pour cette adresse, un e-mail vient d'être envoyé."
          variant="success"
        />
      ) : (
        <form onSubmit={handleSubmit}>
          <Field label="Adresse e-mail" name="email" type="email" autoComplete="email" required />
          <button className="btn" type="submit" disabled={pending}>
            {pending ? 'Envoi…' : 'Envoyer le lien'}
          </button>
        </form>
      )}
      <div className="links">
        <Link to="/login">Retour à la connexion</Link>
      </div>
    </AuthCard>
  );
}
